import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';
import * as moment from 'moment';

@Component({
  selector: 'page-add-seminary',
  templateUrl: 'addSeminary.html',
  providers : [HttpClient, CustomToast]
})
export class AddSeminaryPage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  seminary = {
    title_es : '',
    title_en : '',
    lecturer: '',
    conference_center_es : '',
    conference_center_en : '',
    place : '',
    conference_date : '',
    conference_type : '',
    url : ''
  };

  customToast : CustomToast;
  events : Events;

  minDate = moment().subtract(20,'years').toISOString();
  maxDate = moment().add(20,'years').toISOString();

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.customToast = customToast;
    this.events = events;
	}

  httpPostSeminary(){
    this.httpClient.post('/seminars',this.seminary,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Seminario creado correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('addSeminary:done');
      }
    });
  }

  onClickSave(){
    this.httpPostSeminary();
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/seminars/addSeminary/addSeminary.ts